import { render, staticRenderFns } from "./_userRoleSelect.vue?vue&type=template&id=7fa60e3a"
import script from "./_userRoleSelect.vue?vue&type=script&lang=js"
export * from "./_userRoleSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports